import React, { useEffect, useState } from "react";
import Header from "../../components/website/Header";
import Footer from "../../components/website/Footer";
import { Outlet, useLocation } from "react-router";
import FloatingBar from "../../components/website/FloatingBar";
import Preloader from "../../view/website/preloader/PreLoader";
import FloatingBot from "../../view/website/bot/Floatingbot";
const WebsiteLayout = () => {
  const { pathname } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 6000);
  }, []);
  return (
    <>
      {isLoading ? (
        <Preloader />
      ) : (
        <div>
          <Header />
          <div>
            <Outlet />
            <FloatingBar />
            <FloatingBot />
          </div>
          <Footer />
        </div>
      )}
    </>
  );
};

export default WebsiteLayout;
